import axios from 'axios';

export type UploadProgressCallback = (percentage: number) => void;

export async function uploadFileToS3(
  file: File,
  presignedUrl: string,
  onProgress?: UploadProgressCallback,
): Promise<void> {
  await axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: (event) => {
      const total = event.total ?? file.size;
      const percentage = total > 0 ? Math.min(100, Math.round((event.loaded / total) * 100)) : 0;
      onProgress?.(percentage);
    },
  });
}

export async function downloadFileFromS3(presignedUrl: string): Promise<Blob> {
  const response = await axios.get(presignedUrl, {
    responseType: 'blob',
  });
  return response.data;
}
